// extracted by mini-css-extract-plugin
export default {"toast":"ExamToast_toast__hQlZ1","examToastIn":"ExamToast_examToastIn__EfjMU","toastMessage":"ExamToast_toastMessage__eLVNC"};